/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSectionCollapse = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsSectionCollapse = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);
    this.initAccordions();
    
  },
  initAccordions() {
    const $accordionHeading = $(this.element).find('dt > button');

    $(this.element).find('dd').attr('aria-hidden',true);

    $accordionHeading.attr('aria-expanded',false);

    $accordionHeading.on('click activate',function(){
      const accordionTitle = $(this);
      const accordionIcons = $(this).find('.icon');

      let state = $(this).attr('aria-expanded') === 'false' ? true : false;
      $(this).attr('aria-expanded',state);
      $(this).parent().next().slideToggle(function(){

        if(accordionIcons.hasClass('icon--active')) {
          accordionIcons.toggleClass('icon--active');
        }

      });
      $(this).parent().next().attr('aria-hidden',!state);
      return false;
    });

    $accordionHeading.on('keydown',function(event){
      let keyCode = event.keyCode || e.which;
      if (keyCode === 13){
        $(this).trigger('activate');
      }
    });
  },
  attachEvenListeners: function(){
    
  }
}

/******/ })()
;